import { checkProductAvailability } from "./availability";
const CART_KEY = 'ovlm_cart';

export const CART_UPDATE_EVENT = 'cartUpdate';

export const CartManager = {
  notifyCartUpdate: () => {
    // Dispatch a custom event when cart is updated
    window.dispatchEvent(new CustomEvent(CART_UPDATE_EVENT));
  },

  getCart: () => {
    const cart = localStorage.getItem(CART_KEY);
    return cart ? JSON.parse(cart) : [];
  },

  addToCart: (item) => {
    const cart = CartManager.getCart();
    const existingItemIndex = cart.findIndex(
      (cartItem) => cartItem.id === item.id && 
                    cartItem.startDate === item.startDate && 
                    cartItem.endDate === item.endDate
    );

    if (existingItemIndex === -1) {
      // Only add the item if it doesn't already exist
      cart.push(item);
      localStorage.setItem(CART_KEY, JSON.stringify(cart));
      CartManager.notifyCartUpdate();
      return true;
    } else {
      console.log('This item is already in your cart.');
      return false;
      // You might want to handle this case in the UI, perhaps by showing a message to the user
    }
  },

  removeFromCart: (itemId, startDate, endDate) => {
    let cart = CartManager.getCart();
    cart = cart.filter(
      (item) => !(item.id === itemId && 
                  item.startDate === startDate && 
                  item.endDate === endDate)
    );
    localStorage.setItem(CART_KEY, JSON.stringify(cart));
    CartManager.notifyCartUpdate();
  },

  clearCart: () => {
    localStorage.removeItem(CART_KEY);
    CartManager.notifyCartUpdate();
  },

  getTotalItems: () => {
    return CartManager.getCart().length;
  },

  getTotalPrice: () => {
    const cart = CartManager.getCart();
    return cart.reduce((total, item) => total + (item.price * (item.quantity || 1)), 0);
  },

  getDeposit: () => {
    const cart = CartManager.getCart();
    const deposit = Math.max(...cart.map(item => item.product.caution));
    return deposit;
  },

  validateAndRemoveUnavailableItems: async () => {
    const cart = CartManager.getCart();
    const validatedCart = [];
    let hasRemovedItems = false;

    for (const item of cart) {
      const startDate = new Date(item.startDate);
      const endDate = new Date(item.endDate);
      const currentDate = new Date();

      // Check if dates are in the past
      if (startDate < currentDate || endDate < currentDate) {
        hasRemovedItems = true;
        CartManager.removeFromCart(item.id, item.startDate, item.endDate);
        continue;
      }

      try {
        // Check availability
        const availabilityInfo = await checkProductAvailability(
          item.id,
          startDate,
          endDate,
          item.quantity
        );

        if (!availabilityInfo.available || availabilityInfo.availableQuantity < item.quantity) {
          hasRemovedItems = true;
          CartManager.removeFromCart(item.id, item.startDate, item.endDate);
          continue;
        }

        validatedCart.push(item);
      } catch (error) {
        console.error('Error checking availability for item:', error);
        // On error, keep the item in cart to avoid data loss
        validatedCart.push(item);
      }
    }

    // Update cart with validated items
    localStorage.setItem(CART_KEY, JSON.stringify(validatedCart));
    
    return {
      validatedCart,
      hasRemovedItems
    };
  }
};